import { routeConfig } from './demo';


export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when(
    '/demo',
    routeConfig
  );
}

routes.$inject = ['$routeProvider', '$locationProvider'];
console.log('app.components.demo.routes loaded');
